import axios from 'axios';
import { API_BASE_URL } from '../utils/apiConfig';

class TeacherCurriculumService {
  constructor() {
    this.api = axios.create({
      baseURL: `${API_BASE_URL}/teacher-curriculum`,
    });
  }

  getAuthHeaders() {
    const token = localStorage.getItem('moneysmart-token');
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    };
  }

  // Lessons
  async getLessons(leagueId) {
    try {
      const response = await this.api.get(`/lessons/${leagueId}`, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getLesson(leagueId, lessonId) {
    try {
      const response = await this.api.get(`/lessons/${leagueId}/${lessonId}`, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async createLesson(leagueId, lessonData) {
    try {
      const response = await this.api.post(`/lessons/${leagueId}`, lessonData, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async updateLesson(leagueId, lessonId, lessonData) {
    try {
      const response = await this.api.put(`/lessons/${leagueId}/${lessonId}`, lessonData, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async deleteLesson(leagueId, lessonId) {
    try {
      const response = await this.api.delete(`/lessons/${leagueId}/${lessonId}`, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Quizzes
  async getQuizzes(leagueId) {
    try {
      const response = await this.api.get(`/quizzes/${leagueId}`, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getQuiz(leagueId, quizId) {
    try {
      const response = await this.api.get(`/quizzes/${leagueId}/${quizId}`, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async createQuiz(leagueId, quizData) {
    try {
      const response = await this.api.post(`/quizzes/${leagueId}`, quizData, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async updateQuiz(leagueId, quizId, quizData) {
    try {
      const response = await this.api.put(`/quizzes/${leagueId}/${quizId}`, quizData, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async deleteQuiz(leagueId, quizId) {
    try {
      const response = await this.api.delete(`/quizzes/${leagueId}/${quizId}`, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  handleError(error) {
    if (error.response) {
      // Server responded with error status
      return new Error(error.response.data.error || error.response.data.message || 'An error occurred');
    } else if (error.request) {
      // Request made but no response
      return new Error('No response from server. Please check your connection.');
    } else {
      // Error setting up request
      return new Error(error.message || 'An unexpected error occurred');
    }
  }

  // Student-facing methods
  async getStudentLesson(lessonId) {
    try {
      const response = await this.api.get(`/student/lessons/${lessonId}`, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async getStudentQuiz(quizId) {
    try {
      const response = await this.api.get(`/student/quizzes/${quizId}`, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async completeStudentLesson(lessonId) {
    try {
      const response = await this.api.post(`/student/lessons/${lessonId}/complete`, {}, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  async submitStudentQuizAttempt(quizId, attemptData) {
    try {
      const response = await this.api.post(`/student/quizzes/${quizId}/attempt`, attemptData, this.getAuthHeaders());
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }
}

export default new TeacherCurriculumService();

